import React, { useState, useEffect } from "react";
export default function VerifyEmail() {

    return (
        <>
        <div className="EmailVerifyBox">
          <div>
          <h1>Thank You!</h1>
          <img src={'/images/svg/emailVerifyImg.svg'} className="mx-auto my-3" width={200} alt="Email Verification" />
          <h2>Check Your Email</h2>
          <p>We have sent an email to your registered email.</p>
          {/* <button className="btn text-primary outline-0 border-0">Resend Email</button> */}
          </div>
          </div>
        </>
        
    )

}